import React, { Component } from "react";
import Proptypes from "prop-types";

export default class ViewDigitalOceanVmProviderConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const { currentVmProviderConfig } = this.props;
        return (
            <React.Fragment>
                <tr><td><h4>Name</h4></td><td>{currentVmProviderConfig.config_name || "-"}</td></tr>
                <tr><td><h4>Token</h4></td><td>{currentVmProviderConfig.digital_ocean_token}</td></tr>
                <tr><td><h4>Max Droplets</h4></td><td>{currentVmProviderConfig.max_instances}</td></tr>
                <tr><td><h4>Region</h4></td><td><span>{currentVmProviderConfig.region}</span></td></tr>
                <tr><td><h4>Image</h4></td><td>{currentVmProviderConfig.digital_ocean_droplet_image}</td></tr>
                <tr><td><h4>Droplet Size</h4></td><td>{currentVmProviderConfig.digital_ocean_droplet_size}</td></tr>
                <tr><td><h4>Tags</h4></td><td>{currentVmProviderConfig.digital_ocean_tags}</td></tr>
                <tr><td><h4>SSH Key Name</h4></td><td>{currentVmProviderConfig.digital_ocean_sshkey_name}</td></tr>
                <tr><td><h4>Firewall Name</h4></td><td>{currentVmProviderConfig.digital_ocean_firewall_name}</td></tr>
                <tr><td><h4>Agent Startup Script</h4></td><td><span>{currentVmProviderConfig.startup_script}</span></td></tr>
            </React.Fragment>
        );
    }
}

ViewDigitalOceanVmProviderConfig.propTypes = {
    currentVmProviderConfig: Proptypes.object.isRequired,
};
